import axios from "@/libs/api.request";

export const getExpressCorpList = filterCond => {
  return axios.request({
    url: "config/getExpressCorpList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
export const storeExpressCorpData = data => {
  return axios.request({
    url: "config/storeExpressCorpData",
    data: data,
    csrf: true,
    method: "post"
  });
};

export const unvalidExpressCorp = id => {
  return axios.request({
    url: "config/unvalidExpressCorp",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const restoreExpressCorp = id => {
  return axios.request({
    url: "config/restoreExpressCorp",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const getEnumByCode = code => {
  return axios.request({
    url: "config/getEnumByCode",
    data: { code },
    csrf: false,
    method: "post"
  });
};

export const saveEnumData = data => {
  return axios.request({
    url: "config/saveEnumData",
    data: data,
    csrf: true,
    method: "post"
  });
};

export const getMinProgramSet = () => {
  return axios.request({
    url: "config/getMinProgramSet",
    csrf: false,
    method: "post"
  });
};

export const saveMinProgramSet = data => {
  return axios.request({
    url: "config/saveMinProgramSet",
    data: data,
    csrf: false,
    method: "post"
  });
};
export const getMinProgramPaySet = () => {
  return axios.request({
    url: "config/getMinProgramPaySet",
    csrf: false,
    method: "post"
  });
};

export const saveMinProgramPaySet = data => {
  return axios.request({
    url: "config/saveMinProgramPaySet",
    data: data,
    csrf: false,
    method: "post"
  });
};

export const getOfficalAccountSet = () => {
  return axios.request({
    url: "config/getOfficalAccountSet",
    csrf: false,
    method: "post"
  });
};

export const saveOfficalAccountSet = data => {
  return axios.request({
    url: "config/saveOfficalAccountSet",
    data: data,
    csrf: false,
    method: "post"
  });
};

export const getKuaidiSet = () => {
  return axios.request({
    url: "config/getKuaidiSet",
    csrf: false,
    method: "post"
  });
};

export const setKuaidiSet = data => {
  return axios.request({
    url: "config/setKuaidiSet",
    data: data,
    csrf: false,
    method: "post"
  });
};
